<template>
  <section id="demo" class="py-10 md:py-16 text-center relative overflow-hidden">
      <div class="bg-white/80  backdrop-blur-sm rounded-xl p-8 md:p-12 shadow-lg max-w-4xl mx-auto relative z-10 border border-yellow-100 ">
        <Motion
          :initial="{ opacity: 0, y: 30 }"
          :whileInView="{ opacity: 1, y: 0 }"
          :transition="{ duration: 0.7 }"
          :viewport="{ once: true }"
        >
          <h2 class="text-3xl md:text-4xl font-bold mb-4 text-slate-800 ">
            Try Our <Text3d class="inline-block text-yellow-500 " animate>Demo</Text3d>
          </h2>
          <p class="text-lg text-gray-700  mb-8 max-w-2xl mx-auto">
            Explore our application features without signing up. See how our rubber duck tracking system works!
          </p>
        </Motion>
        
        <Motion
          :initial="{ opacity: 0, y: 20 }"
          :whileInView="{ opacity: 1, y: 0 }"
          :transition="{ duration: 0.7, delay: 0.2 }"
          :viewport="{ once: true }"
        >
          <ShimmerButton
            shimmer-color="rgba(255, 255, 255, 0.8)"
            background="#eab308"
            class="px-8 py-2.5 font-medium inline-flex items-center gap-2 text-white"
            to="/demo"
          >
            <v-icon class="mr-2">mdi-duck</v-icon>
            Try Demo Mode
          </ShimmerButton>
        </Motion>
      </div>
    </section>
  </template>
  
  <script setup lang="ts">
  import { Motion } from 'motion-v';
  import { Text3d } from '@/components/ui/text3d';
  import { ShimmerButton } from '@/components/ui/shimmerButton';
  </script>